/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunMyLearnRobotRequest
 */
export interface RunMyLearnRobotRequest {
    /**
     * The learner's command-palette script. **Open question:** whether the backend
     * renders the model prompt from this (recommended — the client cannot control
     * the prompt), or the frontend supplies pre-rendered prompt text (prompt
     * injection by design, authored by minors, against a shared key).
     * 
     */
    script: { [key: string]: any; };
    /**
     * Only `adversarial` in v1 — the whole point of the robot is that it follows the
     * script pedantically rather than helpfully (D14, and the v1 scope lock). An
     * earlier draft also listed `literal`, which nothing defined and nothing
     * implemented. Difficulty variants belong in the activity manifest's opaque
     * `config`, not in an enum here.
     * 
     */
    mode?: RunMyLearnRobotRequestModeEnum;
}


/**
 * @export
 */
export const RunMyLearnRobotRequestModeEnum = {
    Adversarial: 'adversarial',
} as const;
export type RunMyLearnRobotRequestModeEnum = typeof RunMyLearnRobotRequestModeEnum[keyof typeof RunMyLearnRobotRequestModeEnum];


/**
 * Check if a given object implements the RunMyLearnRobotRequest interface.
 */
export function instanceOfRunMyLearnRobotRequest(value: object): value is RunMyLearnRobotRequest {
    if (!('script' in value) || value['script'] === undefined) return false;
    return true;
}

export function RunMyLearnRobotRequestFromJSON(json: any): RunMyLearnRobotRequest {
    return RunMyLearnRobotRequestFromJSONTyped(json, false);
}

export function RunMyLearnRobotRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunMyLearnRobotRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'script': json['script'],
        'mode': json['mode'] == null ? undefined : json['mode'],
    };
}

export function RunMyLearnRobotRequestToJSON(json: any): RunMyLearnRobotRequest {
    return RunMyLearnRobotRequestToJSONTyped(json, false);
}

export function RunMyLearnRobotRequestToJSONTyped(value?: RunMyLearnRobotRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'script': value['script'],
        'mode': value['mode'],
    };
}

